<template>
    <EditingDialog 
        :context="context"
        :showSnackbar="true"
        maxDialogWidth="1500"
        maxCardHeight="880"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        :useDifferentShowDialogProp="true"
    >
    <template v-slot:editForm> 
        <v-row>
            <!-- Column 1 -->
            <v-col>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="CompanyName"
                        :label="$t('lang_GENERIC_ACCOUNT_COMPANIES_CAPTION_COMPANY_NAME')"
                        rules="required"
                        :alvqa="alvqa +'-textfield-company-name'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown
                        :context="context"
                        field="CompanyAsAzEntry"
                        :items="dropdownAzEntries"
                        :clearable="false"
                        :selection="true"
                        :returnObject="true"
                        :label="$t('lang_ACCOUNT_COMPANIES_PUBLISHING_COMPANIES_CAPTION_AZ_CONNECTION')"
                        :alvqa="alvqa +'-textfield-company-as-az-entry'"
                    /> 
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AddressRow1"
                        :label="$t('lang_AZ_PERSONS_CAPTION_ADDRESS_ROW_1')"
                        rules="required"
                        :alvqa="alvqa +'-textfield-company-name'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AddressRow2"
                        :label="$t('lang_AZ_PERSONS_CAPTION_ADDRESS_ROW_2')"
                        :alvqa="alvqa +'-textfield-company-name'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Zip"
                        :label="$t('lang_AZ_PERSONS_CAPTION_ZIP')"
                        rules="required"
                        :alvqa="alvqa +'-textfield-company-name'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="City"
                        :label="$t('lang_AZ_PERSONS_CAPTION_CITY')"
                        rules="required"
                        :alvqa="alvqa +'-textfield-company-name'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="State"
                        :label="$t('lang_AZ_PERSONS_CAPTION_STATE')"
                        :alvqa="alvqa +'-textfield-company-state'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Country"
                        rules="required"
                        :items="dropdownCountries"
                        :label="$t('lang_AZ_PERSONS_CAPTION_COUNTRY')"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Email"
                        :label="$t('lang_GENERIC_CAPTION_EMAIL')"
                        :alvqa="alvqa +'-textfield-email'"
                    />
                </v-row>
            </v-col>
        
            <!-- Column 2 -->
            <v-col>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="SenderRow"
                        :label="$t('lang_GENERIC_ACCOUNT_COMPANIES_CAPTION_SENDER_ROW')"
                        rules="required"
                        :alvqa="alvqa +'-textfield-company-name'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Ykto"
                        :label="$t('lang_GENERIC_AZ_CAPTION_YKTO')"
                        :alvqa="alvqa +'-textfield-gema-ykto'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Hkto"
                        :label="$t('lang_GENERIC_AZ_CAPTION_HKTO')"
                        :alvqa="alvqa +'-textfield-gema-hkto'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Ukto"
                        :label="$t('lang_GENERIC_AZ_CAPTION_UKTO')"
                        :alvqa="alvqa +'-textfield-gema-ukto'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="VatId"
                        :label="$t('lang_GENERIC_CAPTION_VAT_ID')"
                        :alvqa="alvqa +'-textfield-vat-id'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextarea 
                        :context="context" 
                        field="FooterLeft"
                        rows="5"
                        :label="$t('lang_GENERIC_ACCOUNT_COMPANIES_CAPTION_FOOTER_LEFT')" 
                        :alvqa="alvqa + '-textarea-footer-left'"
                    />
                </v-row>
                <div class="footer-char-counter" :class="{ 'footer-char-counter--exceeded': footerExceedsLimit }">
                    {{ footerTotalLength }} / 180<span v-if="footerExceedsLimit"> — {{ $t('lang_GENERIC_MESSAGE_WARNING_EXCEL_FOOTER_CHAR_LIMIT') }}</span>
                </div>
            </v-col>

            <!-- Column 3 -->
            <v-col>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="InvoicesNumberRange"
                        :label="$t('lang_GENERIC_ACCOUNT_COMPANIES_CAPTION_INVOICES_NO_RANGE')"
                        :alvqa="alvqa +'-textfield-invoices-number-range'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="ShippingNumberRange"
                        :label="$t('lang_GENERIC_ACCOUNT_COMPANIES_CAPTION_SHIPPING_NO_RANGE')"
                        :alvqa="alvqa +'-textfield-shipping-number-range'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="CreditNumberRange"
                        :label="$t('lang_GENERIC_ACCOUNT_COMPANIES_CAPTION_CREDIT_NO_RANGE')"
                        :alvqa="alvqa +'-textfield-credit-number-range'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="StatementNumberRange"
                        :label="$t('lang_GENERIC_ACCOUNT_COMPANIES_CAPTION_STATEMENT_NO_RANGE')"
                        :alvqa="alvqa +'-textfield-statement-number-range'"
                    />
                </v-row>
                <v-row>
                        <BaseEditPageTextField 
                            :context="context"
                            field="Ipi"
                            :label="$t('lang_GENERIC_AZ_CAPTION_IPI')"
                            :alvqa="alvqa +'-textfield-ipi'"
                            :iconTooltipText="$t('lang_PUBLISHING_GENERIC_TOOLTIP_IPI_FORMATTING')"
                        />  
                </v-row>
                <v-row>
                    <BaseEditPageTextarea 
                        :context="context" 
                        field="FooterMiddle"
                        rows="5"
                        :label="$t('lang_GENERIC_ACCOUNT_COMPANIES_CAPTION_FOOTER_MIDDLE')" 
                        :alvqa="alvqa + '-textarea-footer-middle'"
                    />
                </v-row>

            </v-col>

            <!-- Column 4 -->
            <v-col>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="InvoicesNextValue"
                        :label="$t('lang_GENERIC_ACCOUNT_COMPANIES_CAPTION_NEXT_VALUE')"
                        :alvqa="alvqa +'-textfield-invoices-next-value'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="ShippingNextValue"
                        :label="$t('lang_GENERIC_ACCOUNT_COMPANIES_CAPTION_NEXT_VALUE')"
                        :alvqa="alvqa +'-textfield-shipping-next-value'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="CreditNextValue"
                        :label="$t('lang_GENERIC_ACCOUNT_COMPANIES_CAPTION_NEXT_VALUE')"
                        :alvqa="alvqa +'-textfield-credit-next-value'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="StatementNextValue"
                        :label="$t('lang_GENERIC_ACCOUNT_COMPANIES_CAPTION_NEXT_VALUE')"
                        :alvqa="alvqa +'-textfield-statement-next-value'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="CwrSubmitterCode"
                        :label="$t('lang_ACCOUNT_COMPANIES_PUBLISHING_COMPANIES_CAPTION_CWR_SUBMITTER_CODE')"
                        :alvqa="alvqa +'-textfield-cwr-submitter-code'"
                        :maxlength="4"
                        @keydown.native="filterCwrKey"
                        @blur="onCwrBlur"
                        :additionalFunction="toUppercaseCwrSubmitterCode"
                    />
                </v-row>
                <v-row>
                     <BaseEditPageTextarea 
                        :context="context" 
                        field="FooterRight"
                        rows="5"
                        :label="$t('lang_GENERIC_ACCOUNT_COMPANIES_CAPTION_FOOTER_RIGHT')" 
                        :alvqa="alvqa + '-textarea-footer-right'"
                    />
                </v-row>
            </v-col>
        </v-row>

        <v-row>
            <BaseEditPageTextarea 
                :context="context" 
                field="StatementText"
                rows="1"
                :label="$t('lang_GENERIC_ACCOUNT_COMPANIES_CAPTION_STATEMENT_TEXT')" 
                :alvqa="alvqa + '-textarea-statement-text'"
            />
        </v-row>
    </template>
    </EditingDialog>
</template>

<script>

import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseRegions from '@/components/_base/BaseRegions'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'

export default {
    name: "AccountPublishingCompaniesEditPanelDialog",
    components: {
        EditingDialog,
        BaseRegions,
        BaseEditPageTextField,
        BaseEditPageDropdown,
        BaseEditPageTextarea,
    },
    data() {
        return {
            context: "AccountPublishingCompanies",
            alvqa: "account-publishing-companies-panel-editing-dialog"
        }
    },
    computed: {
        dropdownCountries() { 
            return this.$alvPlugin.getListOfTranslatedCountries() 
        },
        footerTotalLength() {
            const left = this.$store.getters['get' + this.context + 'DetailsFooterLeft'] || ''
            const middle = this.$store.getters['get' + this.context + 'DetailsFooterMiddle'] || ''
            const right = this.$store.getters['get' + this.context + 'DetailsFooterRight'] || ''
            return left.length + middle.length + right.length
        },
        footerExceedsLimit() {
            return this.footerTotalLength > 180
        },
        dropdownAzEntries() {
            let dropdown = this.$store.getters.getAccountPublishingCompaniesDetailsCompanyAsAzList
            if(dropdown !== undefined) {
                let dropdownArr = JSON.parse(JSON.stringify(dropdown))
                dropdownArr.forEach(element => {
                    element['alvqa'] = this.alvqa + '-dropdown-company-as-az-list-' + element.id
                    element['text'] = element.name + ' (' + element.alvId + ')'
                    element['value'] = element.id 
                });
                return dropdownArr
            }
        }, 
        
    },
    created() {
        this.$store.commit('setCountries')
    },
    methods: {
        filterCwrKey(evt) {
            const key = evt.key;
            // Allow control keys (delete, backspace, arrows, tab, etc.)
            if (
                key.length > 1 || // Control keys
                /^[A-Za-z0-9]$/.test(key)
            ) {
                return;
            }
            evt.preventDefault();
        },
        toUppercaseCwrSubmitterCode() {
            let value = this.$store.getters['get' + this.context + 'DetailsCwrSubmitterCode'];
            if (typeof value === 'string') {
                let cleaned = value.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 4);
                if (value !== cleaned) {
                    this.$store.commit('set' + this.context + 'DetailsCwrSubmitterCode', cleaned);
                }
            }
        },
        onCwrBlur() {
            let value = this.$store.getters['get' + this.context + 'DetailsCwrSubmitterCode'];
            if (typeof value === 'string' && value.length > 0 && value.length < 2) {
                this.$store.commit('set' + this.context + 'DetailsCwrSubmitterCode', '');
            }
        },
    },
}
</script>

<style scoped>
.footer-char-counter {
    font-size: 12px;
    margin-top: -18px;
    padding-left: 4px;
    color: #9e9e9e;
}
.footer-char-counter--exceeded {
    color: #1565C0;
}
</style>